export const batchTableHeaders = [
  "Batch Number",
  "Manufacture Date",
  "Expiry Date",
  "Available Qty",
  "",
  "",
];
export const batchTableKeys = [
  "batch_number",
  "manufacture_date",
  "expiry_date",
  "quantity_in_stock",
  "edit",
  "delete",
];

// Mutable fields per InventoryConcern#update_params on the backend — batch
// identity (batch_number/dates/cost) is immutable after creation.
export function buildEditBatchForm(packageTypeOptions: { id: string; title: string }[]) {
  return [
    {
      inputType: "number",
      prompt: "Selling price per unit (NGN)",
      name: "selling_price_per_unit",
      placeholder: "Type the selling price per unit",
      fullWidth: false,
      rules: {
        aboveZero: {
          expectedValue: true,
          errorMessage: "Value must be greater than 0",
        },
      },
    },
    {
      inputType: "selectInput",
      prompt: "Selling Package Type",
      name: "selling_package_type",
      placeholder: "Select a package type",
      fullWidth: false,
      returnId: true,
      options: packageTypeOptions,
    },
    {
      inputType: "number",
      prompt: "Reorder Level",
      name: "reorder_level",
      placeholder: "Enter the reorder level",
      fullWidth: false,
    },
    {
      inputType: "number",
      prompt: "Reorder Quantity",
      name: "reorder_quantity",
      placeholder: "Enter the reorder quantity",
      fullWidth: false,
    },
    {
      inputType: "number",
      prompt: "Quantity Defective",
      name: "quantity_defective",
      placeholder: "Enter quantity defective",
      fullWidth: false,
    },
  ];
}
